<div class="background">
  <div class="successMessage alert-dismissible">

    <div class="successMessage alert-dismissible">
      <div *ngIf="warningMessage" class="alert alert-warning" role="alert">
        {{ warningMessage }}
        <button type="button" class="btn-close" (click)="removeMessage()" data-bs-dismiss="alert"
          aria-label="Close"></button>
      </div>

      <div *ngIf="successMessage" class="alert alert-success" role="alert">
        {{ successMessage }}
        <button type="button" class="btn-close" (click)="removeMessage()" data-bs-dismiss="alert"
          aria-label="Close"></button>
      </div>
    </div>
  </div>
  <div class="p-2 messageBackground reset_btn">
    <label class="resetIcon" (click)="goBack()">
      <img src="./assets/images/back arrow.png" alt="bell icon" class="bell" />
    </label>

    <label class="message calendarFont" (click)="goBack()"> BACK</label>
  </div>
  <div class="container-fluid">
    <div class="d-flex flex-row">
      <div class="p-2 flex-grow-1">
        <h2 class="heading">Parts Group</h2>
      </div>
      <div class="p-2">
        <button  type="button" class="search_btn add_btn" style="width: 140px;" (click)="goBack()">
          to count screen
        </button>
        <button  type="button" class="search_btn add_btn" (click)="openAddGroupDialog()"  *ngIf="accessEdit">
          ADD Group
        </button>
      </div>
    </div>
  </div>
  <div class="container-fluid">
    <div class="row">
      <div class="card">
        <div class="container-fluid">
          <div class="row">

            <div class="col-xl-1 col-md-2 col-sm-3">
              <div class="drpchildctrl">
                <span class="v1"></span>
                <label class="searchLable">DOCK</label>
                <p-dropdown
                  [options]="dockList" 
                  [(ngModel)]="selectedDock" 
                  [filter]="true"
                  [virtualScroll]="false" 
                  [itemSize]="12"
                  [showTransitionOptions]="'0ms'" 
                  placeholder="--Select--" 
                  optionLabel="dock"
                  [filterBy]="'dock'"
                  [resetFilterOnHide]="true"
                  [hideTransitionOptions]="'0ms'"
                  autoWidth="false"
                  [style]="{ width: '110%' }" 
                  (onChange)="dockChange()"
                  appendTo="body"
                  scrollHeight="140px" 
                  [panelStyle]="{ width: '61%' }" 
                  >
                </p-dropdown>
              </div>
            </div>
            <div class="col-xl-1 col-md-2 col-sm-3">
              <div class="drpchildctrl">
                <label class="searchLable">ADDRESS </label>
                <p-dropdown 
                  [(ngModel)]="selectedGetAddress" 
                  
                  (onChange)="getAddressChange()"
                  [options]="getAddressList" 
                  [showTransitionOptions]="'0ms'" 
                  [hideTransitionOptions]="'0ms'"
                  placeholder="--Select--" 
                  [virtualScroll]="false" 
                  [itemSize]="12" 
                  autoWidth="false"
                  [style]="{ width: '110%' }" 
                  [resetFilterOnHide]="true" 
                  optionLabel="address"
                  [panelStyle]="{ width: '74%' }"
                  [filter]="true"
                  appendTo="body"
                  scrollHeight="170px" 
                  [filterBy]="'address'"
                  >
                </p-dropdown>
              </div>
            </div>
            
            <!-- <div class="col-xl-1 col-md-2 col-sm-3">
              <div class="drpchildctrl">
                <label class="searchLable">ADDRESS </label>
                <p-multiSelect [(ngModel)]="selectedKanban" [showToggleAll]="false" (onChange)="onKanbanChange()"
                  [options]="kanbanList" [showTransitionOptions]="'0ms'" [hideTransitionOptions]="'0ms'"
                  [defaultLabel]="'--Select--'" [virtualScroll]="true" [itemSize]="25" autoWidth="false"
                  [style]="{ width: '100%' }" [resetFilterOnHide]="true" optionLabel="kanban"
                  [panelStyle]="{ width: '120%' }" [disabled]="disableKanban">
                </p-multiSelect>
              </div>
            </div> -->

            <!-- <div class="col-xl-1 col-md-2 col-sm-3">
              <div class="drpchildctrl">
                <label class="searchLable">KANBAN </label>
                <p-multiSelect [(ngModel)]="selectedKanban" [showToggleAll]="false" (onChange)="onKanbanChange()"
                  [options]="kanbanList" [showTransitionOptions]="'0ms'" [hideTransitionOptions]="'0ms'"
                  [defaultLabel]="'--Select--'" [virtualScroll]="true" [itemSize]="25" autoWidth="false"
                  [style]="{ width: '100%' }" [resetFilterOnHide]="true" optionLabel="kanban"
                  [panelStyle]="{ width: '120%' }" [disabled]="disableKanban">
                </p-multiSelect>
              </div>
            </div> -->

            <!-- <div class="col-xl-1 col-md-2 col-sm-3">
              <div class="drpchildctrl">
                <label class="searchLable">PARTS CONTROL</label>
                <p-multiSelect [(ngModel)]="selectedPartNo" [showToggleAll]="false" (onChange)="onPartNoChange($event)"
                  [options]="partNoList" [showTransitionOptions]="'0ms'" [hideTransitionOptions]="'0ms'"
                  [defaultLabel]="'--Select--'" [virtualScroll]="true" [itemSize]="25" autoWidth="false"
                  [style]="{ width: '100%' }" [resetFilterOnHide]="true" optionLabel="item_id"
                  [panelStyle]="{ width: '140%' }" [disabled]="disablePartNumber" optionDisabled="disabled"
                  selected="false">
                </p-multiSelect>
              </div>
            </div> -->

            <!-- <div class="col-xl-1 col-md-2 col-sm-3">
              <div class="drpchildctrl">
                <label class="searchLable">GROUP </label>
                <p-multiSelect [(ngModel)]="selectedSpecialist" [showToggleAll]="false" (onChange)="specialistChange()"
                  [options]="specialistList" [showTransitionOptions]="'0ms'" [hideTransitionOptions]="'0ms'"
                  [defaultLabel]="'--Select--'" [virtualScroll]="true" [itemSize]="25" autoWidth="false"
                  [style]="{ width: '100%' }" [resetFilterOnHide]="true" optionLabel="EMPLOYEE"
                  [panelStyle]="{ width: '140%' }">
                </p-multiSelect>
              </div>
            </div> -->
            <!-- <div class="col-xl-1 col-md-2 col-sm-3">
              <div class="drpchildctrl">
                <label class="searchLable">SPECIALIST</label>
                <p-multiSelect [(ngModel)]="selectedSpecialist" [showToggleAll]="false" (onChange)="specialistChange()"
                  [options]="specialistList" [showTransitionOptions]="'0ms'" [hideTransitionOptions]="'0ms'"
                  [defaultLabel]="'--Select--'" [virtualScroll]="true" [itemSize]="25" autoWidth="false"
                  [style]="{ width: '100%' }" [resetFilterOnHide]="true" optionLabel="EMPLOYEE"
                  [panelStyle]="{ width: '140%' }">
                </p-multiSelect>
              </div>
            </div> -->

            


            <div class="col-xl-1 col-md-2 col-sm-3 reset_btn">
              <label class="resetIcon" (click)="onResetDropDown()">
                <img src="./assets/images/Group 115380.png" alt="refresh icon" />
              </label>
              <label class="resetlabel" (click)="onResetDropDown()">Reset</label>
              <span class="vertical"></span>
            </div>
            <div class="col-xl-1 col-md-2 col-sm-3 search">
              <button class="search_btn" (click)="triggerManualSearch()">
                SEARCH
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="container-fluid">
    <div class="d-flex flex-row flex-wrap w-100 gap-3">
  
      <!-- Grid 1 -->
      <div class="flex-grow-1" style="min-width: 0;">
        <div class="row flexstyle">
          <div class="col-sm-5"></div>
          <div class="col-sm-7 mb-2">
            <label class="page-drpdwn-label">RECORDS / PAGE:</label>
            <select class="page-drpdwn" (change)="onPageSizeChanged()" [(ngModel)]="paginationPageSize1">
              <option value="10">10</option>
              <option value="30">30</option>
              <option value="50">50</option>
              <option [value]="displayRowData.length">All</option>
            </select>
          </div>
        </div>
  
        <ag-grid-angular
          #grid1
          class="table-outer ag-theme-balham w-100"
          style="height: 660px; margin-bottom: 5%;"
          [columnDefs]="columnDefs1"
          [rowData]="displayRowData"
          [rowSelection]="rowSelection"
          [gridOptions]="gridOptions2"
          [pagination]="true"
          [paginationPageSize]="paginationPageSize1"
          [context]="{ componentParent: this, gridType: 'grid1' }"
          [suppressClickEdit]="suppressClickEdit"
          [frameworkComponents]="frameworkComponents"
          [tooltipShowDelay]="tooltipShowDelay"
          [defaultColDef]="defaultColDef"
          [detailRowAutoHeight]="true"
          [tooltipMouseTrack]="true"
          [editType]="editType">
        </ag-grid-angular>
      </div>
  
      <!-- Arrow Buttons -->
      <div class="d-flex flex-column align-items-center justify-content-center px-2">
        <button class="llp-btn-table mb-2" *ngIf="accessEdit" (click)="rightArrowParts(selectedGroupId)">></button>
        <button class="llp-btn-table" *ngIf="accessEdit" (click)="leftArrowParts(selectedGroupId)"><</button>
      </div>
  
      <!-- Grid 2 + Grid 3 -->
      <div class="flex-grow-1 d-flex flex-column gap-3" style="min-width: 0;">
        
        <!-- Grid 2 -->
        <div>
          <div class="row flexstyle">
            <div class="col-sm-5"></div>
            <div class="col-sm-7 mb-2">
              <label class="page-drpdwn-label">RECORDS / PAGE:</label>
              <select class="page-drpdwn" (change)="onPageSizeChanged()" [(ngModel)]="paginationPageSize">
                <option value="10">10</option>
                <option value="30">30</option>
                <option value="50">50</option>
                <option [value]="rowData.length">All</option>
              </select>
            </div>
          </div>
  
          <ag-grid-angular
            #grid2
            class="table-outer ag-theme-balham w-100"
		        #osPartsGrid
            style="height: 300px; margin-bottom: 5%;"
            [columnDefs]="columnDefs"
            [rowData]="rowData"
            [rowSelection]="rowSelection"
            [gridOptions]="gridOptions"
            [pagination]="true"
            [paginationPageSize]="paginationPageSize"
            [context]="context"
            [suppressClickEdit]="suppressClickEdit"
            [frameworkComponents]="frameworkComponents"
            [tooltipShowDelay]="tooltipShowDelay"
            [defaultColDef]="defaultColDef"
            [detailRowAutoHeight]="true"
            [tooltipMouseTrack]="true"
            [editType]="editType"
            (cellClicked)="onCellClicked($event)">
          </ag-grid-angular>
        </div>
  
        <!-- Grid 3 -->
        <div>
          <div class="row flexstyle mt-2">
            <div class="col-sm-5"></div>
            <div class="col-sm-7 mb-2">
              <label class="page-drpdwn-label">RECORDS / PAGE:</label>
              <select class="page-drpdwn" (change)="onPageSizeChanged()" [(ngModel)]="paginationPageSize2">
                <option value="10">10</option>
                <option value="30">30</option>
                <option value="50">50</option>
                <option [value]="displayRowData1.length">All</option>
              </select>
            </div>
          </div>
  
          <ag-grid-angular
            #grid3
            class="table-outer ag-theme-balham w-100"
            style="height: 300px; margin-bottom: 4%;"
            [columnDefs]="columnDefs2"
            [rowData]="displayRowData1"
            [rowSelection]="'multiple'"
            [gridOptions]="gridOptions3"
            [pagination]="true"
            [paginationPageSize]="paginationPageSize2"
            [context]="{ componentParent: this, gridType: 'grid3' }"
            [suppressClickEdit]="suppressClickEdit"
            [frameworkComponents]="frameworkComponents"
            [tooltipShowDelay]="tooltipShowDelay"
            [defaultColDef]="defaultColDef"
            [detailRowAutoHeight]="true"
            [tooltipMouseTrack]="true"
            [editType]="editType">
          </ag-grid-angular>
        </div>
      </div>
    </div>
  </div>
  <br>
  
</div>

<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
  <p style="font-size: 20px; color: white">Loading... Please wait...</p>
</ngx-spinner>